<template functional>
  <div
    class="grid gap-8"
    :class="`grid-cols-${props.cols}`"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'MiaFormSectionGrid',

  props: {
    cols: {
      type: Number,
      default: 2
    }
  }
}
</script>
